import { useEffect, useState } from "react";
import { useGetReceivingDataAnalyticsQuery } from "../dashBoardApi";
import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import { formatNumber, getCurrentDate } from "../../../helpers/Utils";
import useTranslator from "../../../hooks/useTranslator";

const ReceivingAreaData = ({ startDate , endDate}) => {

  const [currentDate] = useState(getCurrentDate("YYYY-MM-DD"));
  const {
    data : receivingData ,
    isLoading : isReceivingDataLoading ,
    isFetching : isReceivingDataFetching,
    isError : isReceivingError  ,
    refetch : receivingDataRefetch
  } = useGetReceivingDataAnalyticsQuery(
    {
      startDate,
      endDate
    },
    {
      skip: !startDate || !endDate // avoid API call if empty
    }
  );

  const respData = receivingData?.data; 

    
  useEffect(() => {
    receivingDataRefetch();
  }, []);
  

  const { _t } = useTranslator();

  const boxes = [
    { key: "total_cases_entered",  label: _t("case_entered_db",   "Case Entered")  },
    { key: "total_accepted_cases", label: _t("case_accepted_db",  "Case Accepted") },
    { key: "total_rejected_cases", label: _t("case_rejected_db",  "Case Rejected") },
    { key: "total_accepted_kg",    label: _t("accepted_kg_db",    "Accepted KG")   },
    { key: "total_rejected_kg",    label: _t("rejected_kg_db",    "Rejected KG")   },
  ];

  return (
    <DashboardCard
      title={_t("receiving_data", "Receiving Data")}
      badgeIcon={startDate && endDate
        ? <span className="pko-batch-badge">{startDate} → {endDate}</span>
        : null
      }
    >
      <div className="fqm-grid">
        {boxes.map((b) => (
          <div key={b.key} className="pp-brokering-box fqm-box">
            <div className="pp-brokering-box-label">{b.label}</div>
            <div className="pp-brokering-box-value">
              {isReceivingDataLoading
                ? <span className="db-shimmer" style={{ height: 28, width: 60, display: "block" }} />
                : (formatNumber(respData?.[b.key]) ?? "0")
              }
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
};

export default ReceivingAreaData;
